import { render, staticRenderFns } from "./FormImage.vue?vue&type=template&id=53cefc57"
import script from "./FormImage.vue?vue&type=script&lang=js"
export * from "./FormImage.vue?vue&type=script&lang=js"
import style0 from "./FormImage.vue?vue&type=style&index=0&id=53cefc57&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53cefc57')) {
      api.createRecord('53cefc57', component.options)
    } else {
      api.reload('53cefc57', component.options)
    }
    module.hot.accept("./FormImage.vue?vue&type=template&id=53cefc57", function () {
      api.rerender('53cefc57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/form/FormImage.vue"
export default component.exports